import register from '../../../../global/js/registry';
export default register('m-table-contents', () => import(/* webpackMode: "lazy" */ './m-table-contents.controller'));
